var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.licenseHeaders,"items":_vm.deviceLicenses,"options":_vm.deviceLicenseOptions,"server-items-length":_vm.totalDeviceLicenses,"items-per-page":5,"footer-props":{
    showFirstLastPage: true,
    'items-per-page-options': [5, 10, 15],
  }},on:{"update:options":function($event){_vm.deviceLicenseOptions=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }